// The columns that hold one of a fixed set of words, and the words themselves.
//
// M-10. Every one of these is a VARCHAR with no constraint behind it, so the
// database will accept anything at all: 'Active' with a capital A, 'sold ' with
// a trailing space, 'aproved', or a status nobody defined. None of those raise
// an error. The row is simply written, and then never found again, because
// every query that reads it compares against the spelling the rest of the code
// uses. A listing whose status is 'Active' is invisible on the site and present
// in the owner's dashboard, and nothing anywhere reports a problem.
//
// The lists live here rather than only in the migration so that a test can hold
// the two to each other: a value added to the code without being added to the
// constraint would fail at run time, in production, on whoever triggered it.

/**
 * properties.status
 *
 * pending  - waiting for moderation
 * active   - published
 * paused   - taken offline by the owner, can be put back
 * sold     - sold; the page stays up with contact details disabled
 * hidden   - expired, or a draft whose author never confirmed their e-mail
 * rejected - refused by a moderator, with a reason
 * archived - removed by an administrator, recoverable
 * deleted  - removed by the owner, soft-deleted
 */
export const PROPERTY_STATUSES = [
  'pending',
  'active',
  'paused',
  'sold',
  'hidden',
  'rejected',
  'archived',
  'deleted',
] as const;

/**
 * properties.listing_type (rentals, 2026-09-24). 'sale' by default: every
 * listing from before rentals, and every path that does not say otherwise.
 */
export const LISTING_TYPES = ['sale', 'rent'] as const;

/** properties.lease_term - a rental's lease (RESO LeaseTerm, the ones used in Canada). */
export const LEASE_TERMS = ['12_months', '6_months', 'month_to_month', 'short_term', 'negotiable'] as const;

/** properties.furnished */
export const FURNISHED = ['furnished', 'semi', 'unfurnished'] as const;

/** properties.rent_includes - what the rent pays for ("chauffé, éclairé, eau chaude"). */
export const RENT_INCLUDES = ['heating', 'electricity', 'hot_water', 'water', 'internet', 'appliances', 'parking'] as const;

/** users.role */
export const USER_ROLES = ['user', 'realtor', 'admin'] as const;

/**
 * users.agency_status
 *
 * NULL for an account that never asked to be an agency; the three words apply
 * only once one has.
 */
export const AGENCY_STATUSES = ['pending', 'approved', 'rejected'] as const;

/** agency_members.role and agency_invites.role - already constrained in the database. */
export const AGENCY_MEMBER_ROLES = ['manager', 'consultant'] as const;

